
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { COACHING_STYLES } from '@/data/sportsData';

interface CoachingInfoSectionProps {
  formData: {
    years_coaching: string;
    coaching_style: string;
    coaching_certifications: string;
    previous_teams: string;
  };
  onInputChange: (name: string, value: string) => void;
}

export const CoachingInfoSection: React.FC<CoachingInfoSectionProps> = ({
  formData,
  onInputChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Coaching Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="years_coaching" className="text-gray-300">Years of Coaching Experience</Label>
            <Input
              id="years_coaching"
              type="number"
              min="0"
              max="50"
              value={formData.years_coaching}
              onChange={(e) => onInputChange('years_coaching', e.target.value)}
              className="bg-gray-600 border-gray-500 text-white"
            />
          </div>
          <div>
            <Label htmlFor="coaching_style" className="text-gray-300">Coaching Philosophy</Label>
            <Select 
              value={formData.coaching_style} 
              onValueChange={(value) => onInputChange('coaching_style', value)}
            >
              <SelectTrigger className="bg-gray-600 border-gray-500 text-white">
                <SelectValue placeholder="Select coaching style" />
              </SelectTrigger>
              <SelectContent className="bg-gray-600 border-gray-500 max-h-60">
                {COACHING_STYLES.map((style) => (
                  <SelectItem key={style} value={style} className="text-white hover:bg-gray-700">
                    {style}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <div>
          <Label htmlFor="coaching_certifications" className="text-gray-300">Certifications & Qualifications</Label>
          <Textarea
            id="coaching_certifications"
            value={formData.coaching_certifications}
            onChange={(e) => onInputChange('coaching_certifications', e.target.value)}
            placeholder="List your coaching certifications and qualifications..."
            className="bg-gray-600 border-gray-500 text-white placeholder-gray-400"
          />
        </div>

        <div>
          <Label htmlFor="previous_teams" className="text-gray-300">Previous Teams/Organizations</Label>
          <Textarea
            id="previous_teams"
            value={formData.previous_teams}
            onChange={(e) => onInputChange('previous_teams', e.target.value)}
            placeholder="Describe your previous coaching experience..."
            className="bg-gray-600 border-gray-500 text-white placeholder-gray-400"
          />
        </div>
      </CardContent>
    </Card>
  );
};
